export default {
  name: 'UserAgreement',
  components: {}
};